'use strict'
export default (val, min = null, max = null,messageError = null) => {
    let isValid = true;
    if(typeof val == 'number'){
        if(min != null && typeof min == 'number'){
            if(val < min) isValid = false
        }
        if(max != null  && typeof max == 'number'){
            if(val > max) isValid = false
        }
    }else isValid = false;
    if(isValid)return {isValid:true};
    else return {isValid: false, errors: [messageError?messageError:'Invalid Number']};
}